const reasons: { [key: string]: any } = {
  man: [
    { name: 'Operator On leave with information', value: 'level1' },
    {
      name: 'Operator On leave without information (during start of shift)',
      value: 'level2',
    },

    {
      name: 'Operator suddenly leave work place due to accident/illness (after start of production)',
      value: 'level3',
    },
    {
      name: 'Operator return from Long leave (07 days or more then consider as long leave)',
      value: 'level4',
    },
    {
      name: 'New Operator',
      value: 'level20',
    },
  ],
  material: [
    {
      name: 'Material received from other approved source (usually not being used regularly)',
      value: 'level5',
    },
    {
      name: 'Material used from unapproved source without intimation',
      value: 'level6',
    },
    {
      name: 'Different grade material used',
      value: 'level7',
    },
  ],
  method: [
    {
      name: 'Part found on floor or trolley fell down',
      value: 'level8',
    },
    {
      name: 'Fixture sent for validation',
      value: 'level9',
    },
    {
      name: 'Fixture under breakdown',
      value: 'level10',
    },
  ],
  machine: [
    {
      name: 'Machine under preventive maintenance',
      value: 'level11',
    },
    {
      name: 'Machine under breakdown',
      value: 'level12',
    },
    {
      name: 'Die/Tool/Mould under preventive maintenance',
      value: 'level13',
    },
    {
      name: 'Die/Tool/Mould under break down',
      value: 'level14',
    },
    {
      name: 'Machine parameters found out of spec. during routine checking',
      value: 'level15',
    },
    {
      name: 'Power Failure',
      value: 'level16',
    },
    {
      name: 'Repeated Power Failure',
      value: 'level17',
    },
    {
      name: 'Power Source changed with intimation ',
      value: 'level18',
    },
    {
      name: 'Power Source changed after power failure',
      value: 'level19',
    },
  ],
};

const actionTakens: { [key: string]: any } = {
  level1: [
    {
      name: 'Operator of same skill deputed (Operator deputed to work station after long duration)',
      value: 'action1',
    },
  ],
  level2: [
    {
      name: 'Operator of same skill deputed',
      value: 'action1',
    },
    {
      name: 'Operator of under skill deputed ',
      value: 'action2',
    },
  ],
  level3: [
    {
      name: 'Operator of same skill deputed',
      value: 'action1',
    },
    {
      name: 'Operator of under skill deputed ',
      value: 'action2',
    },
  ],
  level4: [
    {
      name: 'On job training provide to Operator before depute on m/c',
      value: 'action1',
    },
  ],
  level5: [
    {
      name: 'Start production after set up approval',
      value: 'action1',
    },
  ],
  level6: [
    {
      name: 'Start production with approved source material',
      value: 'action1',
    },
  ],

  level7: [
    {
      name: 'Stop & get Approval from Customer',
      value: 'action1',
    },
  ],
  level8: [
    {
      name: 'All part kept in suspect bin',
      value: 'action1',
    },
  ],
  level9: [
    {
      name: 'Production done with 2nd set of fixture',
      value: 'action1',
    },
  ],
  level10: [
    {
      name: 'Production done after Fixture maintinance',
      value: 'action1',
    },
    {
      name: 'Production done with temporary Fixture',
      value: 'action2',
    },
  ],
  level11: [
    {
      name: 'Production shifted to same capacity m/c',
      value: 'action1',
    },
    {
      name: 'Production shifted to higher/lower capacity m/c',
      value: 'action2',
    },
  ],
  level12: [
    {
      name: 'Production shifted to same capacity m/c',
      value: 'action1',
    },
    {
      name: 'Production shifted to higher/lower capacity m/c',
      value: 'action2',
    },
    {
      name: 'Working on same machine after repair',
      value: 'action3',
    },
  ],
  level13: [
    {
      name: 'रेProduction done with 2nd set of  Die/Tool/Mould',
      value: 'action1',
    },
  ],
  level14: [
    {
      name: 'Production done with 2nd set of  Die/Tool/Mould',
      value: 'action1',
    },
    {
      name: 'Production done with temporarily repaired Die/Tool/Mould',
      value: 'action2',
    },
  ],
  level15: [
    {
      name: 'Machine started after resetting the parameters',
      value: 'action1',
    },
  ],
  level16: [
    {
      name: 'Restart the m/c',
      value: 'action1',
    },
  ],
  level17: [
    {
      name: 'Restart the m/c',
      value: 'action1',
    },
  ],
  level18: [
    {
      name: 'Restart the m/c after changing the machine parameters, if required',
      value: 'action1',
    },
  ],
  level19: [
    {
      name: 'Restart the m/c after changing the machine parameters, if required',
      value: 'action1',
    },
  ],
  level20: [
    {
      name: 'Provide Training as per Operation Standard',
      value: 'action1',
    },
  ],
};

const actionTakenTickMarks: { [key: string]: any } = {
  level1action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: ``,
  },
  level2action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level2action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: `Check all the parts produced  by the operator`,
  },
  level3action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check all the parts produced  by the operator since last inspection`,
  },
  level3action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `1. Check all the parts produced  by the operator since last inspection 
    2. Check all the parts produced  by the new operator`,
  },
  level4action1: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: `1 Check 1st 2 hours prodn 100%`,
  },
  // material
  level5action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level6action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Reject all the material`,
  },
  level7action1: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Inform to customer and do as guided by the customer`,
  },
  // method
  level8action1: {
    abnormal: 'Abnormal Situation',
    setup: false,
    training: false,
    retro: false,
    suspected: true,
    procedure: `100% Insp. Done with Skilled Inspector`,
  },
  level9action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level10action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check last part produced before breakdown`,
  },
  level10action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Check all the parts produced  with the Fixture`,
  },
  // machine
  level11action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level11action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: `Check all the parts produced  by the machine`,
  },
  level12action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check all the parts produced  since last inspection before m/c breakdown`,
  },
  level12action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: `Check all the parts produced  by the new machine `,
  },
  level12action3: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check all the parts produced since last inspection before m/c breakdown`,
  },
  level13action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level14action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check all the parts produced since last inspection before die/Tool/Mould breakdown`,
  },
  level14action2: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Check all the parts produced  with the Die/Tool/Mould after repair`,
  },
  level15action1: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Check all the parts produced  since last check of parameters`,
  },
  level16action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check last part produced before power failure`,
  },
  level17action1: {
    abnormal: 'Abnormal Situation',
    setup: true,
    training: false,
    retro: true,
    suspected: true,
    procedure: `Check all the parts produced  since start of power failures`,
  },
  level18action1: {
    expected: 'Planned',
    setup: true,
    training: false,
    retro: false,
    suspected: false,
    procedure: ``,
  },
  level19action1: {
    unexpected: 'Unplanned',
    setup: true,
    training: false,
    retro: true,
    suspected: false,
    procedure: `Check last part produced before power failure`,
  },
  level20action1: {
    unexpected: 'Plan Change',
    expected: 'Plan Change',
    setup: true,
    training: false,
    retro: false,
    suspected: true,
    procedure: `1. Take set up approval 2. Provide training to new operator as per Operation standard & inprocess inspection per hours`,
  },
};
export { reasons, actionTakenTickMarks, actionTakens };
